export interface CurrencyProps {
  value: number;
  currency?: string;
  currencyCode?: string;
}

function Currency({ value, ...restProps }: CurrencyProps) {
  const currency = restProps.currency ?? restProps.currencyCode ?? 'USD';
  return <>{formatCurrency({ value, currency })}</>;
}

export function currencyValueToFloat(value: number) {
  return value / 100;
}

/**
 * Parses a formatted currency string (e.g. "$1,234.56") into integer cents.
 * Throws if the string is not a valid dollar amount.
 */
export function parseCurrencyToCents(value: string): number {
  const clean = value.replace(/[$,]/g, '');
  if (!/^\d+(\.\d{1,2})?$/.test(clean)) throw new Error('Invalid amount format');
  return Math.round(Number(clean) * 100);
}

export function floatToCurrencyValue(value: number) {
  return Math.round(value * 100);
}

export function formatCurrency({ value, ...restProps }: CurrencyProps) {
  const currency = restProps.currency ?? restProps.currencyCode ?? 'USD';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(currencyValueToFloat(value));
}

export function toCurrency(value: number, currency = 'USD'): CurrencyProps {
  return {
    value: floatToCurrencyValue(value),
    currency,
  };
}

export function toHNAmount(value: number, currencyCode = 'USD'): CurrencyProps {
  return {
    value: floatToCurrencyValue(value),
    currencyCode,
  };
}

export default Currency;
